const e = { "logged-ticket-private": "{{name}} zalogował to", view: "Widok", "view-ticket": "Zobacz zgłoszenie", meeting: "Spotkanie", "shared-private": "{{name}} udostępnił to", "logged-ticket-public": "{{name}} zalogował to", "shared-public": "{{name}} zalogował to", "crated-meeting-public": "{{name}} udostępnił spotkanie", "crated-meeting-private": "{{name}} utworzył spotkanie" }, t = { ticketing: "System zgłoszeń", messaging: "Wiadomości" }, o = {
  link: e,
  category: t
};
export {
  t as category,
  o as default,
  e as link
};
